// ** React Imports
import React from "react";

// ** Image imports
import image from "../assets/images/polygons.png";

// ** Custom Imports
import TestimonialCard from "./cards/TestimonialCard";
import {staticData} from "../utils/staticData";

// ** Swiper js Imports
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import {Swiper, SwiperSlide} from 'swiper/react';
import {Autoplay, Pagination} from 'swiper/modules';

const TestimonialsSection = () => {


    const backgroundStyle = {
        backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), url(${image})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
    };

    return (
        <div className={'min-h-screen w-screen md:p-12 p-4'} style={backgroundStyle}>

            <div className={'text-center'}>
                <h1 className={'text-6xl text-[57px] font-semibold mb-12'}>Our Success Stories</h1>
                <p className={'text-text-secondary mb-16'}>Celebrating 100% success! Every student who joined our
                    science tuition class has passed with flying colors. Proven teaching methods, expert guidance, and
                    dedicated support—your success starts here!</p>
                <h1 className={'text-3xl text-[24px] font-semibold mb-12'}>What Our Students Say</h1>
            </div>

            <div className="slider-container">
                <Swiper
                    slidesPerView={1}
                    loop={true}
                    pagination={{
                        clickable: true,
                        dynamicBullets: true,
                    }}
                    autoplay={{
                        delay: 5000,
                        disableOnInteraction: false,
                    }}
                    modules={[Autoplay, Pagination]}
                    breakpoints={{
                        320: {slidesPerView: 1},
                        768: {slidesPerView: 2},
                        1280: {slidesPerView: 3},
                    }}
                >
                    {staticData.map((item, index) => (
                        <SwiperSlide key={index}>
                            <TestimonialCard data={item}/>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    )
}

export default TestimonialsSection
